import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { VisorDataService } from 'src/app/shared/callvisordata-shared.service';
import { VisorService } from '../../visor.service';
import { HttpService } from '../../http.service';

@Component({
    selector: 'app-callvisor-modal',
    templateUrl: './callvisor-modal.component.html',
    styleUrls: ['./callvisor-modal.component.scss'],
    standalone: false,
})
export class CallVisorModalComponent implements OnChanges, OnInit {
private router = inject(Router);
private VisorDataService = inject(VisorDataService);
visorService = inject(VisorService);
httpService = inject(HttpService);
private cdr = inject(ChangeDetectorRef);

  @Input() callVisorModalFlag!: boolean;
  @Input() identirydetailEnabled!: boolean ;
  @Input() callVisornotifyText!: string;
  @Output() callVisorModalEmit = new EventEmitter<any>();
  public callvisorData: any;
  public patientNotes:any;
  public facilityId: any;
  public showSuccess = false;
  public loadSpinner = false;
  public phoneNumber:any;
  public showFailure = false;

  private getApiMessage(source: any, fallback: string): string {
    const response = source?.error || source?.body || source;
    return response?.msg || response?.message || source?.msg || source?.message || fallback;
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.VisorDataService.getData().subscribe((data) => {
        this.callvisorData = data;
          // You can perform any additional actions with the received data here
        });
        if (this.callvisorData == undefined || this.callvisorData == null) {
          this.callvisorData = sessionStorage?.getItem('indentityInfoFormGroup') ? JSON.parse(sessionStorage?.getItem('indentityInfoFormGroup') || '{}') : null;
          if(this.callvisorData?.PhoneNumber){
            this.callvisorData.PhoneNumber = this.callvisorData.PhoneNumber.replace(/[^0-9]/g, "");
            this.phoneNumber = '+1'+ this.callvisorData.PhoneNumber;
          }else{
            this.phoneNumber = sessionStorage?.getItem('phoneNumber') || null; 
            if(this.phoneNumber){
              this.phoneNumber = this.phoneNumber.replace(/[^0-9]/g, "");
              this.phoneNumber = '+1'+ this.phoneNumber;
            }
          }
    }
//  this.VisorDataService?.getRefresh().subscribe(data =>{
//         if(data){
//             window.location.reload();
//           }
//       });
    this.getActiveVisorAlert();
  }

  ngOnInit() {
        this.facilityId = sessionStorage?.getItem('headerFacilityId');
        this.getActiveVisorAlert();
  }

  get updateFlag(): boolean {
    return this.callVisorModalFlag;
  }

  public submitModal(): void {
    const users = JSON.parse(sessionStorage?.getItem('allUsers') || '{}')
    this.loadSpinner = true;
    this.showSuccess = false;
    this.showFailure = false;
    this.callVisornotifyText = '';
    this.cdr.detectChanges();
    this.VisorDataService.getData().subscribe((data) => {
      this.callvisorData = data;
      // You can perform any additional actions with the received data here
    });
    if(this.callvisorData == undefined || this.callvisorData == null){
      this.callvisorData = sessionStorage?.getItem('indentityInfoFormGroup') ? JSON.parse(sessionStorage?.getItem('indentityInfoFormGroup') || '{}') : null;
    }
    let phoneNumber :any;
    if(this.callvisorData?.PhoneNumber){
      this.callvisorData.PhoneNumber = this.callvisorData.PhoneNumber.replace(/[^0-9]/g, "");
      phoneNumber = '+1'+ this.callvisorData.PhoneNumber;
    }else{
      phoneNumber = sessionStorage?.getItem('phoneNumber') || null; 
      if(phoneNumber){
        phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
        phoneNumber = '+1'+ phoneNumber;
      }
    }
    const params:any= {
        "facilityId": this.facilityId,
        "patientNotes": this.patientNotes ? btoa(encodeURIComponent(this.patientNotes)) : null,
        "firstName": this.callvisorData?.firstName?.trimEnd() || null,
        "lastName": this.callvisorData?.lastName?.trimEnd() || null,
        "dob": this.callvisorData?.dob || null,
        "phoneNumber": phoneNumber || null,
        'purposeOfVisit': this.callvisorData?.episodeOfCareName || null,
        'episodeOfCareId': this.callvisorData?.episodeOfCareId || null,
        "userInfoId": users?.userInfoId || null
    }
    const action = 'callVisor/saveCallForVisor';
    this.visorService.makePostRequest(action,params).subscribe((response:any) => {
      // Handle the response from the POST request here
      this.loadSpinner = false;
      if(response?.status == 'SUCCESS'){
        this.callVisornotifyText = this.getApiMessage(response, 'We have received your request and will call you within 30 minutes.');
        this.showSuccess = true;
      }else{
        this.callVisornotifyText = this.getApiMessage(response, 'There was a problem submitting your request.');
        this.showFailure = true;
      }
      this.cdr.detectChanges();
    }, (error) => {
      this.loadSpinner = false;
      // Handle any errors that occur during the POST request here
      this.callVisornotifyText = this.getApiMessage(error, 'There was a problem submitting your request.');
      this.showFailure = true;
      this.cdr.detectChanges();
    });
    if(this.patientNotes){
      this.VisorDataService.sendData({
        ...this.callvisorData,
        patientNotes: this.patientNotes
      });
    }
  }


  public getPhoneNumber(data: any): any {
    if (data?.PhoneNumber) {
      const phone = data.PhoneNumber.replace(/[^0-9]/g, "");
      // const cleaned = ('' + data?.PhoneNumber).replace(/\D/g, '');
        // Check if the number has exactly 10 digits
        const match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) {
          // Returns format: (999) 999 9999
          return `(${match[1]}) ${match[2]} ${match[3]}`;
        }
    }else{
      const phone = sessionStorage?.getItem('phoneNumber') || '';
      const cleaned = phone.replace(/[^0-9]/g, "");
        // Check if the number has exactly 10 digits
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) {
          // Returns format: (999) 999 9999
          return `(${match[1]}) ${match[2]} ${match[3]}`;
        }
    }
  }

  public closeModal(): void { 
    this.showSuccess = false;
    this.showFailure = false;
    this.callVisorModalFlag = false;
    this.callVisorModalEmit?.emit(false);
    const refresh= this.visorService.getRefresh();
      if(refresh == 'true'){
         this.visorService.sendRefresh('false')
          window.location.reload();
    }
   // this.router.navigate(['/invoice/invoiceBoard']);
  }

   public getAppointmentTime(date: any): string {
    return this.httpService.convertcallVisordob(date);
  }

  tryAgain(){
    this.showSuccess = false;
    this.patientNotes = '';
    this.showFailure = false;
    this.callVisornotifyText = '';
  }

  //formate name to capitalize first letter
  public formateName(name: string): string {
    if(name){
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }
    return '';
  }

  getActiveVisorAlert(){
      const users = JSON.parse(sessionStorage?.getItem('allUsers') || '{}')
     let phoneNumber :any;
    if(this.callvisorData?.PhoneNumber){
      this.callvisorData.PhoneNumber = this.callvisorData.PhoneNumber.replace(/[^0-9]/g, "");
      phoneNumber = '+1'+ this.callvisorData.PhoneNumber;
    }else{
      phoneNumber = sessionStorage?.getItem('phoneNumber') || null; 
      if(phoneNumber){
        phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
        phoneNumber = '+1'+ phoneNumber;
      }
    }
    const action = 'callVisor/getActiveCallForVisorAlertByUser';
    const params = {
        "facilityId": this.facilityId,
        "firstName": this.callvisorData?.firstName?.trimEnd() || null,
        "lastName": this.callvisorData?.lastName?.trimEnd() || null,
        "dob": this.callvisorData?.dob || null,
        "patientPrimaryPhone": phoneNumber || null,
        'purposeOfVisit': this.callvisorData?.episodeOfCareName || null,
        'episodeOfCareId': this.callvisorData?.episodeOfCareId || null,
        "userInfoId": users?.userInfoId || null
    }
    if (this.callVisorModalFlag) {
      this.loadSpinner = true;
      this.cdr.detectChanges();
    }
    this.visorService.makePostRequest(action,params).subscribe((response:any) => {
      // Handle the response from the POST request here
      this.loadSpinner = false;
      if(response?.status == 'SUCCESS' && response?.responseObject){
        this.showSuccess = true;
        this.callVisornotifyText = response?.message || 'You have an active call with your provider. Please check your call history for more details.';
      }else{
        this.showSuccess = false;
      }
      this.cdr.detectChanges();
    }, (error) => {
      this.loadSpinner = false;
      // Handle any errors that occur during the POST request here
      if (this.callVisorModalFlag) {
        this.callVisornotifyText = this.getApiMessage(error, 'There was a problem checking your active call request.');
        this.showFailure = true;
      }
      this.cdr.detectChanges();
    });
  }
}
